import { AreaController } from "Apis/Controllers/AreaController";
import { AuditTemplateController } from "Apis/Controllers/AuditTemplateController";
import { ChecklistTemplateController } from "Apis/Controllers/ChecklistTemplateController";
import { LoginController } from "Apis/Controllers/LoginController";
import { ShiftController } from "Apis/Controllers/ShiftController";
import { TaskController } from "Apis/Controllers/TaskController";
import { TaskTemplateController } from "Apis/Controllers/TaskTemplateController";
import { AreaSelectionUtil } from "Components/AreaSelection/Utils/AreaSelectionUtil";
import { ChipUtil } from "Components/Common/Chip/Util/ChipUtil";
import { TaskTemplateDetailViewUtil } from "Components/Pages/TaskTemplateDetailView/Utils/TaskTemplateDetailViewUtil";
import { ShiftCalendarUtil } from "Components/ShiftCalendar/Utils/ShiftCalendarUtil";
import { AuditTemplateFilterFactory } from "Factories/Audits/AuditTemplateFilterFactory";
import { IAuditTemplateFilterFactory } from "Factories/Audits/IAuditTemplateFilterFactory";
import { ChecklistTemplateFilterFactory } from "Factories/Checklists/ChecklistTemplateFilterFactory";
import { IChecklistTemplateFilterFactory } from "Factories/Checklists/IChecklistTemplateFilterFactory";
import { ITaskTemplateFilterFactory } from "Factories/Tasks/ITaskTemplateFilterFactory";
import { TaskTemplateFilterFactory } from "Factories/Tasks/TaskTemplateFilterFactory";
import { IAreaController } from "Interfaces/Controllers/IAreaController";
import { IAuditTemplateController } from "Interfaces/Controllers/IAuditTemplateController";
import { IChecklistTemplateController } from "Interfaces/Controllers/IChecklistTemplateController";
import { ILoginController } from "Interfaces/Controllers/ILoginController";
import { IShiftController } from "Interfaces/Controllers/IShiftController";
import { ITaskController } from "Interfaces/Controllers/ITaskController";
import { ITaskTemplateController } from "Interfaces/Controllers/ITaskTemplateController";
import { IAuthenticationService } from "Interfaces/Services/IAuthenticationService";
import { IAreaSelectionUtil } from "Interfaces/Utils/IAreaSelectionUtil";
import { IChipUtil } from "Interfaces/Utils/IChipUtil";
import { IEnvConfigUtils } from "Interfaces/Utils/IEnvConfigUtils";
import { IShiftCalendarUtil } from "Interfaces/Utils/IShiftCalendarUtil";
import { ITaskTemplateDetailViewUtil } from "Interfaces/Utils/ITaskTemplateDetailViewUtil";
import { Container } from "inversify";
import "reflect-metadata";
import { AuthenticationService } from "Services/AuthenticationService";
import { AreaAction, IAreaAction } from "Store/Areas/AreaAction";
import { AuditTemplateAction, IAuditTemplateAction } from "Store/AuditTemplates/AuditTemplateAction";
import { AuthenticationAction, IAuthenticationAction } from "Store/Authentication/AuthenticationAction";
import { ChecklistTemplateAction, IChecklistTemplateAction } from "Store/ChecklistTemplates/ChecklistTemplateAction";
import { ErrorHandlingAction, IErrorHandlingAction } from "Store/ErrorHandling/ErrorHandlingAction";
import { ILoadingAction, LoadingAction } from "Store/Loading/LoadingAction";
import { IMessageToasterAction, MessageToasterAction } from "Store/MessageToaster/MessageToasterAction";
import { IShiftAction, ShiftAction } from "Store/Shifts/ShiftAction";
import { ITaskAction, TaskAction } from "Store/Tasks/TaskAction";
import { ITaskTemplateAction, TaskTemplateAction } from "Store/TaskTemplates/TaskTemplateAction";
import { EnvConfigUtils } from "Utils/EnvConfigUtils";
import Types from "./Types";

const ServiceProvider = new Container();

ServiceProvider.bind<IEnvConfigUtils>(Types.IEnvConfigUtils).to(EnvConfigUtils);
ServiceProvider.bind<IAreaSelectionUtil>(Types.IAreaSelectionUtil).to(AreaSelectionUtil);
ServiceProvider.bind<IChipUtil>(Types.IChipUtil).to(ChipUtil);
ServiceProvider.bind<IShiftCalendarUtil>(Types.IShiftCalendarUtil).to(ShiftCalendarUtil);
ServiceProvider.bind<ITaskTemplateDetailViewUtil>(Types.ITaskTemplateDetailViewUtil).to(TaskTemplateDetailViewUtil);

ServiceProvider.bind<ITaskTemplateFilterFactory>(Types.ITaskTemplateFilterFactory).to(TaskTemplateFilterFactory);
ServiceProvider.bind<IChecklistTemplateFilterFactory>(Types.IChecklistTemplateFilterFactory).to(ChecklistTemplateFilterFactory);
ServiceProvider.bind<IAuditTemplateFilterFactory>(Types.IAuditTemplateFilterFactory).to(AuditTemplateFilterFactory);

ServiceProvider.bind<ILoginController>(Types.IUserInfoController).to(LoginController);
ServiceProvider.bind<ITaskController>(Types.ITaskController).to(TaskController);
ServiceProvider.bind<ITaskTemplateController>(Types.ITaskTemplateController).to(TaskTemplateController);
ServiceProvider.bind<IAuditTemplateController>(Types.IAuditTemplateController).to(AuditTemplateController);
ServiceProvider.bind<IChecklistTemplateController>(Types.IChecklistTemplateController).to(ChecklistTemplateController);
ServiceProvider.bind<IAreaController>(Types.IAreaController).to(AreaController);
ServiceProvider.bind<IShiftController>(Types.IShiftController).to(ShiftController);

ServiceProvider.bind<IAuthenticationAction>(Types.IAuthenticationAction).to(AuthenticationAction);
ServiceProvider.bind<IErrorHandlingAction>(Types.IErrorHandlingAction).to(ErrorHandlingAction);
ServiceProvider.bind<IMessageToasterAction>(Types.IMessageToasterAction).to(MessageToasterAction);
ServiceProvider.bind<ILoadingAction>(Types.ILoadingAction).to(LoadingAction);
ServiceProvider.bind<ITaskAction>(Types.ITaskAction).to(TaskAction);
ServiceProvider.bind<ITaskTemplateAction>(Types.ITaskTemplateAction).to(TaskTemplateAction);
ServiceProvider.bind<IAuditTemplateAction>(Types.IAuditTemplateAction).to(AuditTemplateAction);
ServiceProvider.bind<IChecklistTemplateAction>(Types.IChecklistTemplateAction).to(ChecklistTemplateAction);
ServiceProvider.bind<IAreaAction>(Types.IAreaAction).to(AreaAction);
ServiceProvider.bind<IShiftAction>(Types.IShiftAction).to(ShiftAction);

ServiceProvider.bind<IAuthenticationService>(Types.IAuthenticationService).to(AuthenticationService);

export default ServiceProvider;


// WEBPACK FOOTER //
// ./src/ServiceProvider/ServiceProvider.tsx